<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>{{ pageTitle | translate }}</glxy-page-title>
    <glxy-page-actions>
      @if (secondaryActionButton) {
        <button (click)="secondaryActionButton.handler()" mat-stroked-button>
          @if (secondaryActionButton.icon) {
            <mat-icon>{{ secondaryActionButton.icon }}</mat-icon>
          }
          {{ secondaryActionButton.label | translate }}
        </button>
      }
      @if (primaryActionButton) {
        <button (click)="primaryActionButton.handler()" color="primary" mat-flat-button>
          @if (primaryActionButton.icon) {
            <mat-icon>{{ primaryActionButton.icon }}</mat-icon>
          }
          {{ primaryActionButton.label | translate }}
        </button>
      }
    </glxy-page-actions>
  </glxy-page-toolbar>

  <glxy-page-wrapper [maxWidth]="1200">
    <ng-content></ng-content>
  </glxy-page-wrapper>
</glxy-page>
@if (showRequestReviewButton) {
  <div>
    <app-floating-review-request-button></app-floating-review-request-button>
  </div>
}
